import React from "react";

/**
 * PageShell — the single source of truth for the "sticky viewport,
 * scrollable content" pattern that has bitten this codebase in 4+
 * previous forks. index.css locks <body> to `overflow: hidden` for
 * the PWA feel; every page therefore needs its own scroll container
 * that is exactly 100dvh tall and scrolls internally.
 *
 * Use this instead of hand-rolling `h-screen overflow-y-auto` divs.
 *
 *   <PageShell testid="account-page">
 *     ...content...
 *   </PageShell>
 *
 * `variant="fullbleed"` — the content div spans the full width (used
 * by the landing page). Default is `contained` which is transparent
 * and lets the caller manage its own inner max-width.
 */
export default function PageShell({
    children,
    className = "",
    testid,
    variant = "contained",
    as: Tag = "div",
}) {
    const base = "relative h-[100dvh] w-full overflow-y-auto overflow-x-hidden";
    const variantClass = variant === "fullbleed" ? "" : "";
    return (
        <Tag
            data-testid={testid}
            className={`${base} ${variantClass} ${className}`.trim()}
        >
            {children}
        </Tag>
    );
}
